import ReCAPTCHA from 'react-google-recaptcha';
import { ChangeEvent, useEffect, useState } from 'react';
import { decodeBase64 } from '../../index';
import RecallInput from '../../widget/RecallInput';
import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import { rpcMap } from '@/constants/lang';
import getLocal from '@/app/utils/i18n';
import request from '@/utils/request';
import { baseUrl } from '@/service/util';
import { setLocaleQuery } from '@/utils';

enum SnCodeStatusEnum {
    Success = '0',
    // 已注册
    Registered = '50208',
    // 不符合条件
    NotMeetConditions = '50207',
    // 人机校验重复
    Repeated = '2056',
}

const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;
const successIcon = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6Z"
            stroke="#30BF00"
            strokeWidth="0.88"
        />
        <path d="M2.66699 5.99998L4.75033 8.08331L9.33366 3.70831" stroke="#30BF00" strokeWidth="0.88" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const errorIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
            d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25Z"
            stroke="#F8200C"
            strokeWidth="0.875"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7 8.16671V4.08337" stroke="#F8200C" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 9.91663H7.00583" stroke="#F8200C" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const A = ({ callback }: any) => {
    // 人机验证
    const { t } = useLang('recall.A');
    const { locale } = getLocal();
    const hl = rpcMap[locale];
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const onReCAPTCHAChange = async (captchaCode: string) => {
        if (captchaCode) {
            setRecaptchaResponse(captchaCode);
        }
    };

    // sn码
    const [snCode, setSnCode] = useState('');
    const [status, setStatus] = useState<SnCodeStatusEnum>();
    const [recaptchaKey, setRecaptchaKey] = useState(0);
    const onSubmit = () => {
        request
            .post(`${baseUrl(locale)}/tradeIn/recall/form/snCheck${setLocaleQuery(locale)}`, {
                data: {
                    recaptchaResponse,
                    sn: snCode,
                },
                needToken: true,
            })
            .then((res) => {
                if (res.code === SnCodeStatusEnum.Repeated) {
                    setStatus(undefined);
                    setRecaptchaResponse('');
                    setRecaptchaKey((prev) => prev + 1);
                    return;
                }
                setStatus(res.code);
                callback(snCode, res.code === SnCodeStatusEnum.Success);
            });
    };
    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSnCode(e.target.value);
        setStatus(undefined);
        callback(e.target.value, false);
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const sn = urlParams.get('snCode'); // 读取 snCode
        const can = urlParams.get('can');
        if (sn) {
            setSnCode(sn ? decodeBase64(sn) : '');
            setStatus(decodeBase64(can ?? '') === 'true' ? SnCodeStatusEnum.Success : undefined);
        }
    }, []);
    return (
        <div className={`${css.page}`}>
            <div className="A-title">{t('title')}</div>
            <div className="A-form">
                <div className="A-inputs">
                    <RecallInput className="valueBorder" maxLength={15} value={snCode} onChange={onChange} placeholder={t('placeholder')} />
                    {status === SnCodeStatusEnum.Success && (
                        <div className="A-tips success">
                            {successIcon}
                            <span>{t('success')}</span>
                        </div>
                    )}
                    {status === SnCodeStatusEnum.Registered && (
                        <div className="A-tips error">
                            {errorIcon}
                            <span>{t('error1')}</span>
                        </div>
                    )}
                    {status === SnCodeStatusEnum.NotMeetConditions && (
                        <div className="A-tips error">
                            {errorIcon}
                            <span>{t('error2')}</span>
                        </div>
                    )}
                </div>
                {(recaptchaResponse || status === SnCodeStatusEnum.Success) && (
                    <button className="A-button" onClick={onSubmit}>
                        {t('btn')}
                    </button>
                )}
            </div>
            {/* 人机验证 */}
            {!recaptchaResponse && snCode && SnCodeStatusEnum.Success !== status && (
                // @ts-ignore
                <ReCAPTCHA hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} theme="light" key={recaptchaKey} />
            )}
        </div>
    );
};
export default A;
